export const gbp = (v) =>
  v === null || v === undefined || v === "" ? "—" : new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(v));

export function fmtDate(v) {
  if (!v) return "—";
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split("-");
    return `${d}/${m}/${y}`;
  }
  return new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(v));
}

export function fmtDateTime(v) {
  if (!v) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
  }).format(new Date(v));
}

export const toISODate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const CUSTOMER_REQUEST_LABEL = {
  New: "Request Submitted",
  "Under Review": "Awaiting Review",
  "Awaiting Customer Information": "Information Requested",
  "Consultation Requested": "Appointment Requested",
  "Consultation Booked": "Appointment Confirmed",
  "Quotation in Preparation": "Quotation Being Prepared",
  "Quotation Sent": "Quotation Sent",
  Accepted: "Quotation Accepted",
  Declined: "Declined",
  "Converted to Job": "Job Scheduled",
  Closed: "Closed",
};

const TONES = {
  amber: ["New", "Requested", "Request Submitted", "Awaiting Review", "Under Review", "Awaiting Customer Information",
    "Information Requested", "Consultation Requested", "Appointment Requested", "Rescheduling Requested", "Draft",
    "Awaiting Scheduling", "On Hold", "Quotation Being Prepared"],
  blue: ["Quotation in Preparation", "Quotation Sent", "Sent", "Consultation Booked", "Appointment Confirmed", "Confirmed", "Scheduled"],
  emerald: ["Accepted", "Quotation Accepted"],
  teal: ["In Progress", "Converted to Job", "Job Scheduled"],
  green: ["Completed"],
  rose: ["Declined", "Expired"],
  gray: ["Cancelled", "Closed"],
};
const TONE_CLASS = {
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  blue: "bg-blue-50 text-blue-800 border-blue-200",
  emerald: "bg-emerald-50 text-emerald-800 border-emerald-200",
  teal: "bg-teal-50 text-teal-800 border-teal-200",
  green: "bg-green-100 text-green-900 border-green-300",
  rose: "bg-rose-50 text-rose-800 border-rose-200",
  gray: "bg-stone-100 text-stone-700 border-stone-200",
};
export const toneClass = (status) => {
  const tone = Object.keys(TONES).find((t) => TONES[t].includes(status)) || "gray";
  return TONE_CLASS[tone];
};

export const REQUEST_STATUSES = ["New", "Under Review", "Awaiting Customer Information", "Consultation Requested", "Consultation Booked",
  "Quotation in Preparation", "Quotation Sent", "Accepted", "Declined", "Converted to Job", "Closed"];
export const APPT_STATUSES = ["Requested", "Confirmed", "Rescheduling Requested", "Completed", "Cancelled", "Declined"];
export const QUOTE_STATUSES = ["Draft", "Sent", "Accepted", "Declined", "Expired"];
export const JOB_STATUSES = ["Awaiting Scheduling", "Scheduled", "In Progress", "On Hold", "Completed", "Cancelled"];
export const ACTIVE_JOB = ["Awaiting Scheduling", "Scheduled", "In Progress", "On Hold"];
export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
